export default __webpack_public_path__ + "static/media/bing.d388410e.png";